import React from "react";
import PropTypes from "prop-types";

const Line = ({ className }) => (
  <svg
    width="195"
    height="2547"
    className={className}
    viewBox="0 0 195 2547"
    fill="none"
  >
    <path
      d="M104.193 2344.47C167.255 2325.23 270.037 2275.45 104.193 2243.7M104.193 2344.47C194.96 2364.78 125.105 2447.46 104.193 2310.88M104.193 2344.47C-60.228 2409.93 -3.69337 2399.28 104.193 2378.05M104.193 2546C7.27096 2521.74 0.0849381 2507.18 104.193 2478.82M104.193 2478.82C66.3897 2438.65 10.7792 2415.38 104.193 2378.05M104.193 2478.82C193.683 2455.04 235.374 2442.71 104.193 2445.23C141.733 2428.05 174.263 2422.38 104.193 2411.64C34.1228 2400.91 184.575 2385.36 104.193 2378.05M104.193 2243.7C37.5967 2235.5 31.869 2228.57 104.193 2210.11C161.66 2195.44 165.664 2182.16 104.193 2142.93C65.276 2118.09 39.4699 2104.31 104.193 2075.75C134.132 2062.54 152.461 2042.02 104.193 2008.57C82.0806 1993.25 75.4028 1971.99 104.193 1941.4C128.912 1915.13 116.594 1900.3 104.193 1874.22C79.2417 1821.75 75.2808 1792.33 104.193 1739.86C129.34 1694.22 126.625 1665.59 104.193 1605.5C83.2172 1555.8 67.6683 1528.44 104.193 1471.15C130.128 1425.25 120.619 1396.11 104.193 1336.79C81.069 1231.85 76.7561 1175.72 104.193 1068.08C131.63 960.44 123.302 873.511 104.193 799.366C85.0836 725.22 104.193 703.547 104.193 612.131V0M104.193 2243.7C13.887 2257.73 -16.3725 2265.39 104.193 2277.29C177.756 2290.4 151.188 2297.76 104.193 2310.88M104.193 2243.7C76.4351 2304.01 -56.2077 2370.91 104.193 2378.05M104.193 2310.88C55.1437 2324.2 101.183 2372.13 104.193 2378.05"
      stroke="black"
      strokeWidth="1"
    />
  </svg>
);

Line.defaultProps = {
  className: ``
};

Line.propTypes = {
  className: PropTypes.string
};

export default Line;
